<template>
    <div class="eos-report">
        <div class="eos-report__container">
            <div class="eos-report__container--title">EOS</div>
            <div class="eos-report__container--content">
                <el-tabs class="eos-report__container--content-tabs" v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="EOS Daily Report" name="eosDailyReport">
                        <EosDailyReport />
                    </el-tab-pane>
                    <!-- TODO: Enable this after the revenue & labour history is ready -->
                    <el-tab-pane v-if="env.NAME === 'sandbox'" label="EOS Revenue & Labour History" name="eosRevenueLabourHistory">
                        <EosRevenueLabourHistory />
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import EosDailyReport from "./eosDailyReport.vue";
import EosRevenueLabourHistory from "./eosRevenueLabourHistory.vue";
import { env } from '../../env';
export default {
    data() {
        return {
            activeName: "eosDailyReport",
            env,
        };
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        }
    },
    components: { EosDailyReport, EosRevenueLabourHistory }
}
</script>

<style lang="scss">

.eos-report{
    width: 100%;
    position: relative;
    &__container {
        width: calc(100%);
        z-index: 100;
        background-color: var(--background-color);

        &--title{
            height:33px !important;
            font-size:24px !important;
            font-weight:600 !important;
            color:var(--text-color) !important;
            line-height:33px!important;
            margin-bottom: 40px!important;
        }

        &--content{
            display: flex;
            margin-bottom: 30px;
            position: relative;
        }

        &--content-tabs{
            width: 100%;

            .el-tabs__item {
                color: var(--text-color) !important;
                opacity: 0.6;
                font-size: 16px !important;
                font-weight: 600 !important;
            }

            .el-tabs__active-bar {
                background-color: #ea3796;
            }

            .el-tabs__item.is-active {
               opacity: 1; 
            }

            .el-tabs__nav-wrap::after {
                background-color: transparent !important;
            }

            .el-tabs__content {
                padding: 30px 0px !important;
            }

            .el-input__inner {
                background-color: var(--background-color-3) !important;
                line-height: 50px;
                height: 50px !important;
                font-size: 20px;
                outline: none;
                border: 1px solid #5d5d5d;
                color: var(--text-color) !important;
            }
        }
    }

    &__revenue-labour-history {
        &--date {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 20px;
            gap: 10px;
        }

        .el-collapse-item__header {
             background-color: var(--background-color-3) !important;
             color: var(--text-color) !important;
             font-size: 18px !important;
             font-weight: 600 !important;
             padding: 15px 20px !important;
             border-bottom: 1px solid #5d5d5d !important;
        }

        .el-collapse {
             border-top: 1px solid #5d5d5d !important;
        }

        .el-collapse-item__header {
            border-left: 1px solid #5d5d5d !important;
            border-right: 1px solid #5d5d5d !important;
        }

        .el-collapse-item__content {
            padding: 0px !important;
        }

        .table-wrp .el-table tbody .cell {
            font-size: 15px !important;
        }

        .custom-table .el-table--border .el-table__cell {
            border: 1px solid #ebeef538 !important;
        }

        .el-button--primary {
            background-color: #ea3796 !important;
            border-color: #ea3796 !important;
            
            &:focus, &:hover {
                background-color: rgba(234, 55, 151, 0.6)   !important;
                border-color: rgba(234, 55, 151, 0.6) !important;
            }
        }
    }

    .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
        border-bottom: 1px solid transparent !important;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/eos/eos.vue